import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b89f19ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news" }
const _hoisted_2 = { class: "news-cone" }
const _hoisted_3 = { class: "news-cone-title" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.data ? $setup.data.title : '新闻',
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString($setup.data ? $setup.data.title : ""), 1 /* TEXT */),
      _createElementVNode("div", {
        innerHTML: $setup.data ? $setup.data.content : '',
        class: "sconst"
      }, null, 8 /* PROPS */, _hoisted_4)
    ])
  ]))
}